@if (open) {
  <div
    class="aa-confirm-bar"
    [class.aa-confirm-bar-neutral]="variant === 'neutral'"
    >
    @if (variant === 'warning') {
      <svg class="icon"><use href="#icon-alert-triangle"></use></svg>
      @if (message) {
        <span>{{ message }}</span>
      }
    }
    <div class="aa-confirm-bar-note-body">
      <label class="aa-label-required">{{ noteLabel }}</label>
      <input
        class="aa-input"
        [(ngModel)]="note"
        [placeholder]="notePlaceholder"
        [maxLength]="maxLength"
        (keydown.enter)="confirm()"
        />
      <span class="aa-field-hint" [style.color]="errorHint ? 'var(--aa-danger)' : ''">{{ errorHint }}</span>
    </div>
    <div class="aa-confirm-bar-actions">
      <button class="aa-btn aa-btn-ghost" style="padding:6px 12px; font-size:12px;" (click)="cancel()">Cancel</button>
      <button class="aa-btn aa-btn-primary" style="padding:6px 12px; font-size:12px;" (click)="confirm()">{{ confirmLabel }}</button>
    </div>
  </div>
}
